<template>
  <div>
    <v-dialog v-model="dialog" max-width="600" persistent scrollable>
      <v-form @submit.prevent="addChoice" ref="form">
        <v-card>
          <v-card-title>Add Questionnaire Choice</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    required
                    hide-details="auto"
                    label="Value *"
                    v-model="form.value"
                    :error-messages="form.$getError('value')"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    outlined
                    required
                    hide-details="auto"
                    label="Description"
                    v-model="form.description"
                    :error-messages="form.$getError('description')"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    outlined
                    required
                    hide-details="auto"
                    label="Popup Title"
                    v-model="form.popup.title"
                    :error-messages="form.$getError('popup.title')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    required
                    hide-details="auto"
                    label="Popup Message"
                    v-model="form.popup.message"
                    :error-messages="form.$getError('popup.message')"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <slot>
              <v-btn @click="closeDialog" text>Cancel</v-btn>
              <v-btn type="submit" color="primary" :loading="form.$busy"
                >Submit</v-btn
              >
            </slot>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text @click="snackbar.show = false" v-bind="attrs">OK</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import Questionnaire from '@/models/Questionnaire'
import QuestionnaireChoice from '@/models/QuestionnaireChoice'
import { mapActions } from 'vuex'

export default {
  props: {
    questionnaire: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialog: this.value,
      form: new Form({
        value: null,
        description: null,
        popup: {
          title: null,
          message: null
        }
      }),
      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  methods: {
    ...mapActions({
      getQuestionnaireDetailsAction: 'questionnaires/getQuestionnaireDetails'
    }),

    addChoice() {
      this.form.$busy = true
      this.form.$clearErrors()
      const formData = JSON.parse(JSON.stringify(this.form.$data()))

      if (!formData.popup.title && !formData.popup.message) {
        formData.popup = null
      }

      new QuestionnaireChoice(formData)
        .for(new Questionnaire(this.questionnaire))
        .save()
        .then(res => {
          this.getQuestionnaireDetailsAction(this.questionnaire.id)
        })
        .then(() => {
          this.closeDialog()
          this.showSnackbar(
            'New choice for questionnaire has been created!',
            'success'
          )
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
        .finally(() => (this.form.$busy = false))
    },

    closeDialog() {
      this.dialog = false
      this.$refs.form.reset()
      this.form.$clearErrors()
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  },

  watch: {
    dialog(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.dialog = val
    }
  }
}
</script>
